<ul class="list-group rounded-0">
    <li class="list-group-item" *ngFor="let person of persons; let i = index;">
        <div class="row p-0">
            <!-- Specific classes if use checkboxes -->
            <div [ngClass]="{ 'col-9': useCheckboxes, 'col-11': !useCheckboxes }" (click)="toggle(person.dossierPersonId)">
                <!-- Display checkbox -->
                <input id="person_{{person.dossierPersonId}}" *ngIf="useCheckboxes" [disabled]="personIsDisabled(person.dossierPersonId)" class="form-check-input checkbox mt-1" type="checkbox" [checked]="person.checked">

                <!-- Display name of actor -->
                <label for="person_{{person.dossierPersonId}}" [ngClass]="{ 'disabled': personIsDisabled(person.dossierPersonId) }" (click)="$event.stopPropagation();" class="fs-12">{{ person.firstname }} {{ person.prefix }} {{ person.lastname }}</label>
            </div>
            <!-- Action column -->
            <div [ngClass]="{ 'col-3': useCheckboxes, 'col-1': !useCheckboxes }"><span class="float-end badge rounded-pill fs-12 text-lowercase"
                [ngClass]="{ 'bg-warning': countActionsOfActor(person.dossierPersonId) == 0, 'bg-success': countActionsOfActor(person.dossierPersonId) > 0 }">{{countActionsOfActor(person.dossierPersonId)}}
                {{ countActionsOfActor(person.dossierPersonId) == 1 ? ('Request.Actions.Action' | translate) :
                ('Request.Actions.Actions' | translate) }} </span></div>
        </div>
    </li>
</ul>